
const translation = {
  nav_used_pallets: "Palés Usados",
  nav_new_pallets: "Palés Nuevos",
  nav_services: "Servicios",
  nav_about: "Sobre Nosotros",
  nav_faq: "FAQ",
  nav_contact: "Contacto",
  nav_get_quote: "Presupuesto",

  hero_location: "Amberes, Bélgica",
  hero_title_line1: "PALÉS EURO",
  hero_title_line2: "DE PRIMERA CALIDAD",
  hero_subtitle: "Proveedor de confianza de palés usados Grado A, Grado B y palés de madera nuevos. Inspección de calidad. Entrega rápida en toda Bélgica.",
  hero_cta_quote: "Solicitar Presupuesto",
  hero_cta_products: "Ver Productos",

  stat_years: "Años de Experiencia",
  stat_pallets: "Palés Entregados",
  stat_grades: "Grados de Producto",
  stat_quality: "Control de Calidad",

  gallery_label: "Calidad Que Se Ve",
  gallery_title: "Nuestra Colección de Palés",
  gallery_grade_a: "Grado A Premium",
  gallery_grade_b: "Grado B Económico",
  gallery_new: "Palés Nuevos",
  gallery_custom: "Pedidos Especiales",

  how_label: "Proceso Simple",
  how_title: "Cómo Funciona",
  how_subtitle: "Desde la navegación hasta la entrega, hacemos que pedir palés sea rápido y sencillo.",
  how_step1_title: "Explorar & Seleccionar",
  how_step1_desc: "Explore nuestra gama de palés Grado A, Grado B y nuevos. Vea especificaciones detalladas y fotos.",
  how_step2_title: "Solicitar Presupuesto / Pedido",
  how_step2_desc: "Envíe una solicitud de presupuesto o realice un pedido directo en línea. Confirmamos en 24 horas.",
  how_step3_title: "Entrega Rápida",
  how_step3_desc: "Reciba sus palés rápidamente en toda Bélgica y Europa. Todos los pedidos se verifican antes del envío.",

  used_label: "Palés Usados de Calidad",
  used_title: "Palés Euro Usados",
  used_subtitle: "Elija entre Grado A premium o Grado B económico. Todos inspeccionados y listos para uso inmediato.",

  new_label: "Palés Completamente Nuevos",
  new_title: "Palés de Madera Nuevos",
  new_subtitle: "Palés certificados ISPM15, listos para exportación, fabricados según los más altos estándares. Tamaños personalizados disponibles.",

  product_quick_specs: "Especificaciones Rápidas",
  product_dimensions: "Dimensiones",
  product_load: "Capacidad de Carga",
  product_wood: "Tipo de Madera",
  product_order_now: "Pedir Ahora",
  product_view_details: "Ver Detalles",
  product_view_angles: "Ángulos & Detalles",
  product_tech_specs: "Especificaciones Técnicas",
  product_key_features: "Características Clave",
  product_request_quote: "Solicitar Presupuesto para Este Producto",
  product_call_us: "Llámenos",

  calc_current_price: "Precio Actual",
  calc_volume_hint: "Precios por volumen disponibles – ¡pida más y ahorre más!",
  calc_total_price: "Precio Total",
  calc_price_per: "Precio por palé",
  calc_quantity: "Cantidad",
  calc_pallets: "palés",
  calc_order_now: "Pedir",
  calc_current_selection: "Selección Actual",
  calc_pieces: "piezas",
  calc_per_pallet: "por palé",
  calc_calculate: "Calcular Su Pedido",
  calc_payment_methods: "MÉTODOS DE PAGO DISPONIBLES",
  calc_volume_pricing: "Precios por Volumen",
  calc_bulk_discount: "Descuento por volumen aplicado",
  calc_min_order: "Pedido mínimo: 10 palés",
  calc_payment_methods_label: "Métodos de pago:",
  calc_total: "Total:",
  calc_select_qty: "Seleccionar Cantidad y Pago",
  calc_total_price_label: "Precio Total",

  services_label: "Lo Que Hacemos",
  services_title: "Nuestros Servicios",
  services_subtitle: "Desde la clasificación hasta la entrega, proporcionamos soluciones completas de palés para su negocio.",
  service1_title: "Clasificación de Palés",
  service1_desc: "Inspección manual experta y clasificación de cada palé.",
  service2_title: "Suministro a Granel",
  service2_desc: "Pedidos de grandes cantidades bienvenidos. Precios competitivos para compras al por mayor.",
  service3_title: "Pedidos Personalizados",
  service3_desc: "¿Necesita tamaños no estándar? Fabricamos palés de madera a medida.",
  service4_title: "Entrega Rápida",
  service4_desc: "Entrega fiable en toda Bélgica y Europa.",

  quality_label: "Nuestros Estándares",
  quality_title: "Sistema de Grados de Calidad",
  quality_subtitle: "Cada palé que suministramos es cuidadosamente inspeccionado y clasificado según estrictos estándares europeos.",
  grade_a_label: "Grado Premium",
  grade_b_label: "Grado Estándar",
  grade_new_label: "Completamente Nuevo",

  about_label: "Quiénes Somos",
  about_title: "El Socio de Palés de Confianza de Amberes",
  about_p1: "PEL Partner Company es un proveedor especializado de palés Euro con sede en Amberes, Bélgica. Suministramos a empresas de toda Bélgica y Europa palés de alta calidad.",
  about_p2: "Ya sea que necesite palés Grado A premium, Grado B económicos o palés nuevos para exportación — tenemos la solución correcta al precio correcto.",
  about_location: "Amberes, Bélgica",
  about_quality: "Cada palé inspeccionado",
  about_delivery: "Rápido en toda Bélgica",
  about_support: "Lun–Vie 8:00–18:00",
  about_years: "Años en el Negocio",
  about_supplied: "Palés Suministrados",

  videos_label: "Véalo en Acción",
  videos_title: "Nuestras Operaciones",
  videos_subtitle: "Vea cómo clasificamos, inspeccionamos y preparamos los palés.",
  tab_sorting: "Proceso de Clasificación",
  tab_quality: "Control de Calidad",
  tab_delivery: "Entrega",
  video_sorting_title: "Clasificación e Inspección Manual",
  video_sorting_desc: "Cada palé se verifica manualmente para garantizar la calidad",
  video_strict: "Inspección Estricta",
  video_strict_desc: "Cada palé se inspecciona manualmente para verificar la integridad estructural y el cumplimiento EPAL.",
  video_sorted: "Clasificado por Grado",
  video_sorted_desc: "Los palés se clasifican cuidadosamente en Grado A, B y Nuevos.",
  video_reliable: "Entrega Fiable",
  video_reliable_desc: "Entregamos en todo Amberes y Bélgica con tiempos de respuesta rápidos.",

  why_title: "¿Por Qué Elegir PEL Partner?",
  why1_title: "Calidad Certificada",
  why1_desc: "Palés certificados EPAL, cada lote inspeccionado según estándares europeos.",
  why2_title: "Precios Competitivos",
  why2_desc: "Mejores precios en Amberes para palés Grado A, B y nuevos.",
  why3_title: "Entrega Rápida",
  why3_desc: "Procesamiento rápido de pedidos y entrega en toda Bélgica.",
  why4_title: "Socio Fiable",
  why4_desc: "Relaciones a largo plazo basadas en confianza, consistencia y calidad.",

  delivery_label: "Entregamos en Toda Bélgica",
  delivery_title: "Nuestras Áreas de Servicio",
  delivery_subtitle: "Entrega rápida y fiable de palés a las principales ciudades y regiones de Bélgica y Europa.",

  faq_label: "Preguntas Frecuentes",
  faq_title: "Preguntas Frecuentes",
  faq_subtitle: "Encuentre respuestas a las preguntas más comunes sobre nuestros palés, servicios y proceso de pedido.",
  faq_q1: "¿Qué grados de palés ofrecen?",
  faq_a1: "Ofrecemos tres grados: Grado A (palés usados premium en excelente estado), Grado B (palés usados económicos con desgaste menor) y Palés de Madera Nuevos (nuevos, certificados ISPM15 para exportación).",
  faq_q2: "¿Cuál es la cantidad mínima de pedido?",
  faq_a2: "Atendemos pedidos de todos los tamaños, desde pequeñas cantidades hasta pedidos a granel. Contáctenos para discutir sus requisitos específicos.",
  faq_q3: "¿A qué áreas entregan?",
  faq_a3: "Entregamos en toda Bélgica, incluyendo Amberes, Bruselas, Gante, Brujas y Lieja. También servimos a clientes en toda Europa.",
  faq_q4: "¿Cuáles son sus plazos de entrega?",
  faq_a4: "Los palés usados Grado A y B generalmente están en stock y disponibles para entrega inmediata. Los palés nuevos pueden requerir 1-2 semanas.",
  faq_q5: "¿Sus palés están certificados EPAL?",
  faq_a5: "Sí, nuestros palés Grado A están certificados y sellados con EPAL. Todos los palés nuevos están tratados térmicamente ISPM15 y sellados.",
  faq_q6: "¿Ofrecen tamaños de palés personalizados?",
  faq_a6: "Sí, podemos fabricar palés de madera nuevos en dimensiones personalizadas. El tamaño estándar EUR/EPAL es 1200 × 800 mm.",
  faq_q7: "¿Cómo garantizan la calidad de los palés?",
  faq_a7: "Cada palé es inspeccionado manualmente por nuestro personal capacitado. Verificamos la integridad estructural y el cumplimiento EPAL.",
  faq_q8: "¿Qué métodos de pago aceptan?",
  faq_a8: "Aceptamos transferencias bancarias, tarjetas de crédito y podemos acordar condiciones de pago para clientes establecidos.",

  contact_label: "Contáctenos",
  contact_title: "Póngase en Contacto",
  contact_info_title: "Información de Contacto",
  contact_phone_label: "Teléfono",
  contact_email_label: "Correo Electrónico",
  contact_location_label: "Ubicación",
  contact_hours_label: "Horario Comercial",
  contact_hours_val: "Lunes – Viernes: 8:00 – 18:00",
  contact_call_now: "Llamar Ahora",
  contact_email_us: "Enviar Email",
  contact_quote_title: "Solicitar Presupuesto",
  form_name: "Nombre",
  form_phone: "Teléfono",
  form_email: "Correo Electrónico",
  form_product: "Producto",
  form_product_placeholder: "Seleccionar un producto...",
  form_product_a: "Palés Euro Usados — Grado A",
  form_product_b: "Palés Euro Usados — Grado B",
  form_product_new: "Palés de Madera Nuevos",
  form_product_mixed: "Pedido Mixto",
  form_message: "Mensaje",
  form_message_placeholder: "Cuéntenos sobre sus requisitos, cantidad necesaria...",
  form_send: "Enviar Solicitud",
  form_sending: "Enviando...",
  form_success_title: "¡Mensaje Enviado!",
  form_success_desc: "Nos pondremos en contacto con usted lo antes posible.",
  form_send_another: "Enviar Otro",
  form_error: "Algo salió mal. Por favor, inténtelo de nuevo.",

  order_title: "Realizar su Pedido",
  order_subtitle: "Complete sus datos y confirmaremos su pedido en 24 horas.",
  order_company: "Nombre de la Empresa",
  order_company_ph: "Nombre de su empresa",
  order_contact: "Nombre de Contacto",
  order_contact_ph: "Su nombre completo",
  order_quantity: "Cantidad",
  order_quantity_ph: "Número de palés",
  order_address: "Dirección de Entrega",
  order_address_ph: "Calle, Ciudad, Código Postal",
  order_date: "Fecha de Entrega Preferida",
  order_notes: "Notas Adicionales",
  order_notes_ph: "Requisitos especiales o preguntas...",
  order_cancel: "Cancelar",
  order_review: "Revisar Pedido",
  order_summary_title: "Resumen del Pedido",
  order_summary_subtitle: "Por favor, revise los detalles de su pedido antes de enviar.",
  order_company_info: "Información de la Empresa",
  order_company_name_label: "Nombre de la Empresa",
  order_contact_label: "Persona de Contacto",
  order_email_label: "Correo Electrónico",
  order_phone_label: "Teléfono",
  order_details: "Detalles del Pedido",
  order_product_label: "Producto",
  order_qty_label: "Cantidad",
  order_qty_unit: "palés",
  order_address_label: "Dirección de Entrega",
  order_date_label: "Fecha Preferida",
  order_notes_label: "Notas Adicionales",
  order_next_steps: "Próximos Pasos:",
  order_next_steps_desc: "Después de enviar este pedido, nuestro equipo lo revisará y se pondrá en contacto con usted en 24 horas.",
  order_edit: "Editar Pedido",
  order_confirm: "Confirmar & Enviar",
  order_submitting: "Enviando su Pedido...",
  order_submitting_desc: "Por favor, espere un momento.",
  order_success_title: "¡Pedido Enviado con Éxito!",
  order_ref_label: "Número de Referencia",
  order_success_desc: "¡Gracias por su pedido! Revisaremos su solicitud y nos pondremos en contacto con usted en 24 horas.",
  order_close: "Cerrar",
  order_error: "Algo salió mal. Por favor, inténtelo de nuevo.",

  footer_products: "Productos",
  footer_contact: "Contacto",
  footer_copyright: "© 2025 PEL Partner Company. Todos los derechos reservados.",
  footer_tagline: "Amberes, Bélgica — Proveedor de Palés Euro",
  footer_desc: "Su proveedor de confianza de palés Euro en Amberes, Bélgica. Palés Grado A, B y nuevos — calidad garantizada.",

  // Comparison Table
  compare_label: "Comparativa",
  compare_title: "Compara Nuestros Grados de Palés",
  compare_subtitle: "¿No sabes qué grado es el adecuado para ti? Compara las tres opciones de un vistazo.",
  compare_feature: "Característica",
  compare_grade_a: "Grado A",
  compare_grade_b: "Grado B",
  compare_new: "Palés Nuevos",
  compare_condition: "Estado",
  compare_condition_a: "Excelente — desgaste mínimo",
  compare_condition_b: "Bueno — desgaste cosmético menor",
  compare_condition_new: "Nuevo — sin uso",
  compare_certification: "Certificación",
  compare_certification_a: "Certificado EPAL",
  compare_certification_b: "Inspeccionado",
  compare_certification_new: "Certificado ISPM15",
  compare_load: "Capacidad de Carga",
  compare_load_a: "Hasta 1500 kg",
  compare_load_b: "Hasta 1000 kg",
  compare_load_new: "Hasta 2000 kg",
  compare_export: "Listo para Exportar",
  compare_export_a: "Solo UE",
  compare_export_b: "Solo UE",
  compare_export_new: "Mundial",
  compare_custom: "Tamaños Personalizados",
  compare_custom_a: "No",
  compare_custom_b: "No",
  compare_custom_new: "Sí",
  compare_availability: "Disponibilidad",
  compare_availability_a: "En Stock",
  compare_availability_b: "En Stock",
  compare_availability_new: "Bajo Pedido",
  compare_best_for: "Ideal Para",
  compare_best_for_a: "Uso alimentario, mercancías sensibles",
  compare_best_for_b: "Almacenamiento general",
  compare_best_for_new: "Exportación y envíos internacionales",
  compare_starting_price: "Precio Inicial",
  compare_cta: "Pedir Ahora",
  compare_yes: "Sí",
  compare_no: "No",
};

export default translation;
